import { LoginBonusKind } from '../../../../services/exports/Constants';
import useMobileAppSignupBonus from './handlers-by-kind/useMobileAppSignupBonus';
import { LoginBonusHandler } from '../../types';

const useGetHandlerByKind = () => {
  const handlersByKind: Readonly<Record<LoginBonusKind, ReturnType<LoginBonusHandler>>> = {
    [LoginBonusKind.MobileAppSignupBonus]: useMobileAppSignupBonus(),
  };

  return (kind: LoginBonusKind) => handlersByKind[kind];
};

export default useGetHandlerByKind;
